/**
 * Created by vaibhav on 29/06/16.
 */

function qtipPostioning(qtip_options, ele) {
    var offSet = $(ele).offset();
    var winH = $(window).height();
    var winW = $(window).width();
    var left = offSet.left;
    var right = offSet.left + $(ele).width();
    var top = offSet.top;
    var bottom = offSet.top + $(ele).height();
    var div_height = qtip_options.elements.tooltip.height();
    var div_width = qtip_options.elements.tooltip.width();
    var xPos = 0;
    var yPos = 15;
    var mouseX = qtip_options.cache.mouse.x;
    var mouseY = qtip_options.cache.mouse.y;
    xCondition = ($('#leftpanel').is(":visible")) ? $('#leftpanel').width() : 50;
    yCondition = (!$('#tblIns').is(":visible")) ? $('.datagrid-footer').height() : 100;
    //condition 1
    if (div_width + mouseX + xCondition > winW)
        xPos = -(div_width);
    //condition 2
    if (div_height + mouseY + yCondition > winH)
        yPos = -(div_height);

    return {x: xPos, y: yPos};
}


function qtipSettings(ele, qttype, panel) {
    //user defined defaults
    $.fn.qtip.styles.defaults.padding = "8px 19px";
    if (qttype != "qttitle") {
        qttype = "note";
        width = 315;
        if ($(ele).attr('note') && $(ele).attr('note').length > 600){
            width = 600;
        }
    }
    else {
        if (qttype == "qttitle" && $(ele).attr('qttitle')) {
            // Here to find the width of the title, we have first found the line with maximum character
            // then we have added it in the span to find it's widht

            var hiddenSpan = $('<span style="font-size:11px;padding:8px 19px;border:3px solid rgb(226, 226, 226);"></span>').hide();
            $('body').append(hiddenSpan);

            var titleValueArray = $(ele).attr('qttitle').split('<br>');

            var titleValue = titleValueArray.sort(function (a, b) {
                return b.length - a.length
            })[0];

            $(hiddenSpan).text(titleValue);
            width = $(hiddenSpan).outerWidth() || '';

            // Removed the hidden once the width have been set
            $(hiddenSpan).remove();
        }
    }
    if ($(ele).find('div').length > 0) {
        newEle = $(ele).find('div').eq(0);
        $(newEle).attr(qttype, $(ele).attr(qttype));
        ele = newEle;
    }
    if (panel == true)
        width = '';
    if ($(ele).attr(qttype) == "" || $(ele).attr(qttype) == undefined)
        return;
    if ('object' === typeof $(ele).data('qtip'))
        $(ele).qtip('destroy');
    $(ele).qtip({
        content: $(ele).attr(qttype), // Use the tooltip attribute of the element for the content
        style: {
            width: width,
            name: 'light',
            tip: false
        }, // Give it a cream style to make it stand out
        position: {
            target: 'mouse',
            adjust: {
                mouse: false,
                x: 10,
                y: 10
            },
            corner: {}
        },
        api: {
            beforeShow: function () {
                tip_position = qtipPostioning(this, ele);
                this.options.position.adjust.x = tip_position.x;
                this.options.position.adjust.y = tip_position.y;
                if($('[qtip="'+ $(ele).qtip('api').id + '"].qtip-active').length > 1){
                    $('[qtip="'+ $(ele).qtip('api').id + '"].qtip-active').css('display', 'none');
                }
            }
        }
    });
}
